import React from 'react';
import cn from 'classnames';
import LazyImage from 'components/UI/LazyImage';
import Link from 'components/UI/Link';
import { useLang } from 'utils/localisation';
import * as styles from './ReviewPlatform.module.scss';

export default function ReviewPlatform({ type, link, className }) {
  const lang = useLang();
  const iconSrc = getIcon(type, lang);

  if (iconSrc) {
    return (
      <Link href={link} className={cn(styles.reviewPlatform, className)}>
        <LazyImage className={styles.reviewPlatformIcon} src={iconSrc} alt={type} />
      </Link>
    );
  }

  return null;
}

function getIcon(type, lang) {
  switch (type) {
    case 'Clutch.co':
      return lang === 'ae'
        ? 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/clutch-verified-stars-rtl.svg'
        : 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/clutch-verified-stars.svg';
    case '99firms':
      return 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/firms-verified.svg';
    case 'GoodFirms':
      return 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/good-firms-verified.svg';
    default:
      return undefined;
  }
}
